(function() {
'use strict';

angular
    .module('dashboard')
    .controller('CsrDetails', CsrDetails);

function CsrDetails($routeParams,
                    dashboardCsrService) {
    const cm = this;

    cm.getCSRStatus = status => dashboardCsrService.getCSRStatus(status);
    cm.bookingId = $routeParams.bookingId;
    cm.getCsrStatusClass = status => dashboardCsrService.getCsrStatusClass(status);

    cm.returnUrl = `/dashboard/csr/${cm.bookingId}`;

    dashboardCsrService.getCSRDetail($routeParams.csrId).then(function(res) {
        cm.csrDetails = res;
    });
}
})();
